import { render } from "./PaymentConfirmed.vue?vue&type=template&id=f1a68630"
import script from "./PaymentConfirmed.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmed.vue?vue&type=script&lang=js"

import "./PaymentConfirmed.vue?vue&type=style&index=0&id=f1a68630&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__